import React, { useState, useEffect } from "react";
import {
  clearInterval,
  clearTimeout,
  setInterval,
  setTimeout,
} from "worker-timers";
import timerpng from "../../../assets/img/time2.png";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useIdleTimer, workerTimers } from "react-idle-timer";
import { useSelector, useDispatch } from "react-redux";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../StateManagement/actions";

function SessionTimeoutComponent() {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const history = useNavigate();
  const [openSession, setOpenSession] = useState(false);
  const [timerText, settimertimerText] = useState(selectedLanguage.LstLanguageCodes.UI_YouwillbeloggedoutIn);
  const [timerValue, settimerValue] = useState("5 minute(s) & 00 second(s).");
  var max_sessiontimeout_count = 1800000;
  var max_sessionpopup_count = 300000;


  const onIdle = () => {
    setOpenSession(false);
    history(`/`);
  };

  const onActive = () => {
    setOpenSession(false);
  };
  const onPrompt = () => {
    setOpenSession(true);
  };

  const {
    start,
    reset,
    activate,
    pause,
    resume,
    isIdle,
    isPrompted,
    isLeader,
    getTabId,
    getRemainingTime,
    getElapsedTime,
    getLastIdleTime,
    getLastActiveTime,
    getTotalIdleTime,
    getTotalActiveTime,
  } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout: max_sessiontimeout_count,
    promptBeforeIdle: max_sessionpopup_count,
    events: [
      //'mousemove',
      "keydown",
      //'wheel',
      //'DOMMouseScroll',
      //'mousewheel',
      "mousedown",
      //'touchstart',
      //'touchmove',
      //'MSPointerDown',
      //'MSPointerMove',
      //'visibilitychange'
    ],
    crossTab: true,
    timers: workerTimers,
    debounce: 0,
    throttle:1,
    startManually: false,
    name: "sesssion-timer",
    syncTimers: 1,
  });

  useEffect(() => {
    const interval = setInterval(() => {
        //console.log(Math.ceil(getRemainingTime()/1000));
      if (
        Math.ceil(getRemainingTime() / 1000) <
        max_sessionpopup_count / 1000
      ) {
        var tempTime = moment.duration(
          Math.ceil(getRemainingTime() / 1000),
          "s"
        );
        var minutes = tempTime.get("minutes");
        var seconds = tempTime.get("seconds");
        var timeToShow=selectedLanguage.LstLanguageCodes.UI_MinutesSeconds;
        var timerValueformating = timeToShow.replace("{0}", minutes).replace("{1}", seconds);
        settimertimerText(selectedLanguage.LstLanguageCodes.UI_YouwillbeloggedoutIn);
        settimerValue(timerValueformating);
      }
      else{
        setOpenSession(false);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });
  const handleToClose = () => {
    setOpenSession(false);
    reset();
  };

  return (
    <>
      {openSession === true && (
        <div
          className="modal modalCus"
          id="myModal1"
          style={{ display: "block" , zIndex:9999}}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="justify-content-center d-flex mt-2">
                  <img
                    src={timerpng}
                    alt="Time"
                    className="check"
                    height="90px"
                  />
                </div>
                <div className="mt-3">
                  <h5
                    className="text-center my-2 mt-3 res-font14"
                    style={{ fontSize: "17px", color: "black" }}
                  >
                    {selectedLanguage.LstLanguageCodes.UI_YoursessionisaboutExpire}
                  </h5>
                  <h5
                    className="text-center mt-2 mb-2"
                    style={{ fontSize: "17px", color: "black" }}
                  >
                    {timerText+" "+timerValue}
                  </h5>
                  <h5
                    className="text-center my-2 res-font14"
                    style={{ fontSize: "17px", color: "black" }}
                  >
                    {selectedLanguage.LstLanguageCodes.UI_ClicktoContinue}
                  </h5>
                </div>
                
                <div className="mt-4 mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className=" btn btn-primary px-5"
                    data-bs-dismiss="modal"
                    onClick={handleToClose}
                  >
                    {selectedLanguage.LstLanguageCodes.UI_Continue}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SessionTimeoutComponent;
